
document.addEventListener('DOMContentLoaded' , () =>{
	if(document.querySelector('.promotion-view-page')){
		//floating tab
		const floatingTab = document.getElementById("js_tab1");
		const scrollBtn = document.querySelectorAll('.tab__btn');

		window.onscroll = function () {
			let windowTop = window.scrollY;
			if(windowTop >= 100){
				floatingTab.classList.add("fixed");
			}else{
				floatingTab.classList.remove("fixed");
			}
		};

		scrollBtn.forEach(el => {
		  el.addEventListener('click', function () {
			let scrollPosition = document.querySelector(this.dataset.scroll).offsetTop - 40;
		
			window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
		  });
		});

		//coupon toggle
		const couponBtn = document.querySelectorAll('.js-btn-coupon');
	
		couponBtn.forEach(el => {
			el.addEventListener('click' , function(){
				if(el.classList.contains('active')){
					el.classList.remove('active');
					el.innerHTML = '유의사항 열기';
				}else{
					el.classList.add('active');
					el.innerHTML = '유의사항 닫기';
				}
			});
		});  
	}
});
